// extracted by mini-css-extract-plugin
export default {"state":"ScheduleMain_state__N4+NB","placeVoteRow":"ScheduleMain_placeVoteRow__FJCbX","placeVoteBtn":"ScheduleMain_placeVoteBtn__1HUJ+"};